import React, { Component } from 'react';

class MenuItem extends Component {
    constructor(props) {
        super(props);
        this.onHover = this.onHover.bind(this);
        this.onUnhover = this.onUnhover.bind(this);
        this.handleClick = this.handleClick.bind(this);

        this.state = {
            isHover: false
        }
    }

    onHover() {
        this.props.handleMouseOver();
        this.setState({ isHover: true });
    }

    onUnhover() {
        this.props.handleMouseOut();
        this.setState({ isHover: false });
    }

    handleClick(id) {
        this.props.handleClick(id)
    }

    render() {
        const { menuStyle, scene } = this.props;
        let sceneStyle = Object.assign({}, menuStyle);
        sceneStyle.color = this.state.isHover ? sceneStyle.hoverColor : sceneStyle.color;
        return (
            <div
                style={{ marginBottom: '0.3em' }}
                onMouseOver={this.onHover}
                onMouseOut={this.onUnhover}
                onClick={() => this.handleClick(scene.id)}
            >
                <span className="linked-store-scene" style={sceneStyle}> {scene.name} </span>
            </div>
        )
    }
}

export default MenuItem;